import { Box, styled } from "@mui/material";
import { FC, Fragment, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import CustomerDashboardSidebar from "./CustomerDashboardSideBar";
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSideBar";

const Wrapper = styled(Box)(({ theme }) => ({
  width: "calc(100% - 88px)",
  marginLeft: 88,
  paddingInline: 24,
  paddingBottom: 24,
  [theme.breakpoints.down("md")]: {
    width: "100%",
    marginLeft: 0,
    paddingInline: 16,
  },
}));

const WrapperCustomer = styled(Box)(({ theme }) => ({
  width: "calc(100% - 240px)",
  marginLeft: 240,
  paddingInline: 24,
  paddingBottom: 24,
  [theme.breakpoints.down("md")]: {
    width: "100%",
    marginLeft: 0,
    paddingInline: 16,
  },
}));

interface CustomProps {
  children?: React.ReactNode;
  isCustomerAccess?: boolean;
}

const DashboardLayout: FC<CustomProps> = ({
  children,
  isCustomerAccess,
}): React.ReactElement => {
  const [showMobileSideBar, setShowMobileSideBar] = useState(false);

  useEffect(() => {
    document.body.style.overflow = showMobileSideBar ? "hidden" : "auto";
  }, [showMobileSideBar]);

  return (
    <Fragment>
      {isCustomerAccess ? (
        <CustomerDashboardSidebar
          showMobileSideBar={showMobileSideBar}
          closeMobileSideBar={() => setShowMobileSideBar(false)}
        />
      ) : (
        <DashboardSidebar
          showMobileSideBar={showMobileSideBar}
          closeMobileSideBar={() => setShowMobileSideBar(false)}
        />
      )}

      {isCustomerAccess ? (
        <WrapperCustomer>
          <DashboardNavbar
            setShowMobileSideBar={() => setShowMobileSideBar((state) => !state)}
            hideSidebar={false}
            isCustomerAccess={isCustomerAccess}
          />
          {children || <Outlet />}
        </WrapperCustomer>
      ) : (
        <Wrapper>
          <DashboardNavbar
            setShowMobileSideBar={() => setShowMobileSideBar((state) => !state)}
            hideSidebar={false}
          />
          {children || <Outlet />}
        </Wrapper>
      )}
    </Fragment>
  );
};

export default DashboardLayout;
